<div>
  <div [class.hide]="fileData === null" id="croppieContainer" class="crop-image-container margin-bottom"></div>
  @if (fileData) {
    <div class="zoom-controls">
      <button type="button" class="zoom-button" [attr.aria-label]="'crop_image_zoom_out' | translate" (click)="zoomOut()">
        <ds-icon [icon]="Icons.Minus" [iconStyle]="IconStyles.Light"></ds-icon>
      </button>
      <div #zoomerHost class="zoomer-host"></div>
      <button type="button" class="zoom-button" [attr.aria-label]="'crop_image_zoom_in' | translate" (click)="zoomIn()">
        <ds-icon [icon]="Icons.Plus" [iconStyle]="IconStyles.Light"></ds-icon>
      </button>
    </div>
  }
  @if (fileData && showActions) {
    <div class="get-cropped-image">
      <button type="button" class="btn btn-default" (click)="onGetCroppedImage()">Get Image</button>
    </div>
  }
</div>
